import { Box, Alert } from '_shared/designSystem/components';

export default function NoPermissionAlert() {
  return (
    <Box mt={5}>
      <Alert message="You do not have permission to view this content" status="warning" />
    </Box>
  );
}
